import ClearLayout from "@/auth/components/layout/clear-layout";
import { useState } from "react";
import { useSearchParams } from "react-router-dom";
import toast from "react-hot-toast";
import { Logo } from "@/shared/components/common/logo";
import AcceptInviteForm, { AcceptInviteInput } from "@/auth/components/forms/accept-invite-form.tsx";
import { useAcceptInvite } from "@/auth/api/queries/auth.queries.ts";
import { AUTH_URL } from "@/auth/routes.ts";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

const AcceptInvite = () => {
  const { t } = useTranslation("auth");
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token");
  const { mutateAsync: acceptInvite } = useAcceptInvite();
  const navigate = useNavigate();

  const onHandleSubmit = async (data: AcceptInviteInput) => {
    if (!token) {
      toast.error(t("acceptInvite.errors.invalidToken"));
      return;
    }

    setIsLoading(true);

    try {
      const response = await acceptInvite({
        token,
        password: data.password,
      });

      if (!response) {
        toast.error(t("acceptInvite.errors.activationFailed"));
        setIsLoading(false);
        return;
      }

      toast.success(t("acceptInvite.success"));
      navigate(AUTH_URL.SIGN, { replace: true });

    } catch (e: any) {
      console.error("Accept invite error:", e);

      let errorMessage = t("acceptInvite.errors.activationFailed");

      if (e?.response?.data) {
        const errorData = e.response.data;
        if (errorData.error) {
          errorMessage = errorData.error;
        } else if (errorData.message) {
          errorMessage = errorData.message;
        } else if (errorData.detail) {
          errorMessage = errorData.detail;
        } else if (errorData.non_field_errors) {
          errorMessage = Array.isArray(errorData.non_field_errors)
            ? errorData.non_field_errors[0]
            : errorData.non_field_errors;
        }
      } else if (e?.message) {
        errorMessage = e.message;
      }

      if (e?.response?.status === 400) {
        errorMessage = t("acceptInvite.errors.invalidOrExpired");
      } else if (e?.response?.status === 404) {
        errorMessage = t("acceptInvite.errors.notFound");
      } else if (e?.response?.status >= 500) {
        errorMessage = t("errors.serverError");
      } else if (!e?.response) {
        errorMessage = t("errors.networkError");
      }

      toast.error(errorMessage);
      setIsLoading(false);
      return;
    }
  };
  return (
    <ClearLayout>
      <div className="flex flex-col w-full gap-8 justify-center items-center">
        <Logo alt={t("logoAlt")} className="h-16 w-auto" />
        <AcceptInviteForm isLoading={isLoading} onSubmit={onHandleSubmit} />
      </div>
    </ClearLayout>
  );
};

export default AcceptInvite;